<template>
  <span>
    <b-icon-dash-circle-fill scale="1.4" @click="$bvModal.show(modalId)"/>

    <b-modal ref="modal" :id="modalId" title="Delete client" centered>
      <b-container fluid>
        <b-row>
          <b-col sm="12">
            Really delete client <strong>{{ client.name }}</strong>?
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <div class="error">{{ err }}</div>
          </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="danger" @click="deleteClient">
          <b-spinner small v-show="processing"></b-spinner>
          <span v-show="!processing">Delete</span>
        </b-button>
      </template>
    </b-modal>
  </span>
</template>


<script>

import {API} from "aws-amplify";
import {refreshClients, store} from "@/main";


export default {
  name: "DeleteClientButton",
  props: {
    client: Object,
  },
  data: function() {
    return {
      processing: false,
      err: ' ',
    }
  },
  computed: {
    modalId: function() {
      return 'modal-delete-client-' + this.client.id
    },
  },
  methods: {
    deleteClient() {
      this.processing = true;
      this.err = ' ';
      API.post(store.state.api, "/del", {
        body: JSON.stringify({
          q: 2,
          clientId: this.client.id,
        }),
      })
          .then((response) => {
              if (response === true) {
                  this.processing = false;
                  this.$refs['modal'].hide()
                  refreshClients()
              } else {
                  throw response
              }
          })
          .catch(() => {
            this.processing = false;
            this.err = 'Error: you must first delete all API keys and all Keycloaks'
          });
    }
  },
}
</script>



<style scoped>
.error {
  display: block;
  color: red;
  margin-top: 10px;
  text-align: center;
}
.b-icon {
  cursor: pointer;
  transition: color .2s ease;
  color: #aaa;
}
.b-icon:hover {
  color: #dc3545;
}
</style>